import { render } from "./SaveSectionOptions.vue?vue&type=template&id=2cacb812&scoped=true&ts=true"
import script from "./SaveSectionOptions.vue?vue&type=script&lang=ts"
export * from "./SaveSectionOptions.vue?vue&type=script&lang=ts"

import "./SaveSectionOptions.vue?vue&type=style&index=0&id=2cacb812&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cacb812"]])

export default __exports__